import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { useState, useRef } from 'react'
import { Button, Drawer, Stack, Typography } from '@mui/material'
import { updateCompanyLogo } from "features/account/service/AccountProfileService";
import { useSnackbar } from "components/snackbar/SnackbarContext";
import { useLayout } from "components/layout/LayoutComponentContext";

export default function AccountChangeLogoComponent({ isOpen, onBack, onClose }) {
  const { setMessage } = useSnackbar();
  const fileInputRef = useRef(null);

  const { companyProfile, refetchCompany } = useLayout();
  const [logoUrl, setLogoUrl] = useState(companyProfile?.logo_url);


  const handleFileChange = async (event) => {
    const file = event.target.files?.[0]
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setMessage({
          title: "Failed",
          desc: "File exceeds 2 MB",
          type: "error",
        });
        fileInputRef.current.value = ''
        return
      }
      const form = new FormData()
      form.append("file", file)
      const response = await updateCompanyLogo(companyProfile?.company_id, form)
      if (response?.info?.title === "success") {
        const reader = new FileReader()
        reader.onload = (e) => {
          setLogoUrl(e.target?.result)
        }
        reader.readAsDataURL(file)
        setMessage({
          title: "Success",
          desc: "Company logo updated",
          type: "success",
        });
        refetchCompany()
      } else {
        setMessage({
          title: "Failed",
          desc: response,
          type: "error",
        });
        fileInputRef.current.value = ''
      }
    }
  }

  const handleUploadClick = () => {
    fileInputRef.current?.click()
  }

  const handleRemovePhoto = async () => {
    setLogoUrl(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
    const form = new FormData()
    form.append("file", null)
    const response = await updateCompanyLogo(companyProfile?.company_id, form)
    if (response?.info?.title === "success") {
      setMessage({
        title: "Success",
        desc: "Company logo removed",
        type: "success",
      });
      refetchCompany()
    } else {
      setMessage({
        title: "Failed",
        desc: response,
        type: "error",
      });
      fileInputRef.current.value = ''
      return
    }
  }

  return (
    <Drawer
      className="account-profile-drawer"
      anchor="right"
      open={isOpen}
      onClose={onClose}
    >
      <Stack className="header" direction="row" justifyContent="space-between" alignItems="center">
        <img alt='close-profile-icon' className='cursor-pointer' src='/images/sidebar/sidebar-back.svg' onClick={onBack} />
        <p className='account-profile-title'>Change Logo</p>
        <img alt='close-profile-icon' className='cursor-pointer' src='/images/close-profile-icon.svg' onClick={onClose} />
      </Stack>
      <Stack className="container" spacing={3} alignItems="center">
        {logoUrl ? (
          <img src={logoUrl} alt="Company logo" className="w-40 h-40 rounded-full shrink-0 object-cover" />
        ) : (
          <AccountCircleRoundedIcon
            viewBox="2 2 20 20"
            aria-label='account-profile-image-default'
            className="p-0"
            sx={{ height: "160px", width: "160px", color: "#ccc" }}
          />
        )}
        <Typography color="#5F737F" textAlign="center" fontSize={12}>
          Max. file size 2MB (.jpg,<br /> .jpeg, .png)
        </Typography>
        <Stack spacing={1}>
          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={handleFileChange}
            ref={fileInputRef}
            style={{ display: 'none' }}
          />
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleUploadClick}
            className="w-[200px]"
          >
            <Typography fontWeight={800} fontSize={12}>Upload Photo</Typography>
          </Button>
          <Button
            color="error"
            onClick={handleRemovePhoto}
            disabled={!logoUrl}
            className="w-[200px]"
          >
            <Typography fontWeight={800} fontSize={12}>Remove Photo</Typography>
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  )
}